import gql from 'graphql-tag';
import AdminProductCategoryAllDataFragment from '../fragments/AdminProductCategoryAllDataFragment';

export default gql`
mutation createProductCategory (
    $name: String!
    $parent_id: Int
    $url_key: String!
    $content: String
    $is_enable: Boolean!
    $date_to: String
    $date_from: String
    $show_in_menu: Boolean!
    $keywords: String
    $description: String
    $is_promotion: Boolean!
    $is_homepage_prohibited: Boolean!
    $promotion_place: PromotionPlace
) {
    createProductCategory (input: {
        name: $name,
        parent_id: $parent_id,
        url_key: $url_key,
        content: $content,
        is_enable: $is_enable,
        date_to: $date_to,
        date_from: $date_from,
        show_in_menu: $show_in_menu,
        keywords: $keywords,
        description: $description,
        is_promotion: $is_promotion
        is_homepage_prohibited: $is_homepage_prohibited
        promotion_place: $promotion_place
    }) {
        ...AdminProductCategoryAllDataFragment
    }
}
${AdminProductCategoryAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createProductCategory.ts